import React from 'react';
import data from '../resources/scholarship.json'
import Table from '../components/table';

const Scholarship = () => {  
    return (
      <div className="App">
        <h1 style={{
                borderBottom: '2px solid rgb(109, 169, 228)',
                display: 'inline-block',
                marginTop: '45px'
            }}>Scholarship</h1>
        <Table data={data} text={'Apply'}/>
      </div>
    );
  };
  
  export default Scholarship;